import FakePgCodeApi from "./FakePgCodeApi";
import RealPgCodeApi from "./RealPgCodeApi";
import CommonRequestBodyDto from "../dto/common/CommonRequestBodyDto";
import PgCodeSaveReqDto from "../dto/pgcode/PgCodeSaveReqDto";
import PgCodeUpdateReqDto from "../dto/pgcode/PgCodeUpdateReqDto";

class PgCodeApi {
    fakeApi = false;
    fake = new FakePgCodeApi();
    real = new RealPgCodeApi();

    getPgCode = ({ storeId }: { storeId: string }) => {
        if (this.fakeApi) {
            return this.fake.getPgCode();
        } else {
            return this.real.getPgCode({ storeId });
        }
    };

    savePgCode = (reqDto: CommonRequestBodyDto<PgCodeSaveReqDto>) => {
        if (this.fakeApi) {
            return this.fake.savePgCode();
        } else {
            return this.real.savePgCode(reqDto);
        }
    };

    updatePgCode = (reqDto: CommonRequestBodyDto<PgCodeUpdateReqDto>) => {
        if (this.fakeApi) {
            return this.fake.updatePgCode();
        } else {
            return this.real.updatePgCode(reqDto);
        }
    };
}

export default PgCodeApi;
